export default __webpack_public_path__ + "static/media/service01.2c276327.svg";